const readersBankAccount = '1002-583-860513';
const readersBankAccountHolder = '윤영훈';
const readersBankName = '우리은행';

export {
    readersBankAccount,
    readersBankAccountHolder,
    readersBankName
}